/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports1ColumnBannerViewProps } from './hosports-1-column-banner';

export default (props: IHosports1ColumnBannerViewProps) => {
    return (
        <h2>{'hosports-one-column-banner-view'}</h2>
    );
};
